/**
 *
 * Actions Service Actions
 *
 */

import {
  ACTIONS_REQUEST,
  NOT_ASKED,
  LOADING,
  SUCCESS,
  FAILURE,
} from './constants';

/**
 * Kicks off the saga that initiates the request.
 */
export function actionsRequest(transferId, body, actionType, successMessage='', errorMessagePrefix='') {
  return {
    type: ACTIONS_REQUEST,
    transferId,
    body,
    actionType,
    successMessage,
    errorMessagePrefix,
  };
}

/**
 * Used by the saga to set the status.
 */
export function notAsked() {
  return {
    type: NOT_ASKED,
  };
}

/**
 * Used by the saga to set the status and store body.
 */
export function loading(transferId, body) {
  return {
    type: LOADING,
    transferId,
    body,
  };
}

/**
 * Used by the saga to set the status and store result.
 */
export function success(result) {
  return {
    type: SUCCESS,
    result,
  };
}

/**
 * Used by the saga to set the status and store the error.
 */
export function failure(error) {
  return {
    type: FAILURE,
    error,
  };
}



// WEBPACK FOOTER //
// ./src/services/actions/actions.js